export const getSessionFilter = (key) => {
  try {
    const stored = sessionStorage.getItem('dashboardFilters');
    return stored ? JSON.parse(stored)[key] : undefined;
  } catch (error) {
    console.error('Error reading from sessionStorage:', error);
    return undefined;
  }
};

export const setSessionFilter = (key, value) => {
  try {
    const current = JSON.parse(sessionStorage.getItem('dashboardFilters') || '{}');
    current[key] = value;
    sessionStorage.setItem('dashboardFilters', JSON.stringify(current));
  } catch (error) {
    console.error('Error writing to sessionStorage:', error);
  }
};

export const clearSessionFilter = (key) => {
  try {
    const current = JSON.parse(sessionStorage.getItem('dashboardFilters') || '{}');
    if (key) {
      delete current[key];
    } else {
      // Clear all filters if no key provided
      sessionStorage.removeItem('dashboardFilters');
      return;
    }
    sessionStorage.setItem('dashboardFilters', JSON.stringify(current));
  } catch (error) {
    console.error('Error clearing sessionStorage:', error);
  }
};
